import React, { useState } from 'react';
import { personalInfo } from '../data/portfolio';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [status, setStatus] = useState('idle');
  const [formErrors, setFormErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.email.trim()) newErrors.email = 'Email is required';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) newErrors.email = 'Invalid email format';
    if (!formData.subject.trim()) newErrors.subject = 'Subject is required';
    if (!formData.message.trim()) newErrors.message = 'Message is required';
    else if (formData.message.trim().length < 20) newErrors.message = 'Message must be at least 20 characters';
    setFormErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const emailBody = [
      `Name: ${formData.name}`,
      `Email: ${formData.email}`,
      '',
      formData.message,
    ].join('\n');
    const mailtoUrl = `mailto:${personalInfo.email}?subject=${encodeURIComponent(formData.subject)}&body=${encodeURIComponent(emailBody)}`;

    window.location.href = mailtoUrl;
    setStatus('success');
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (formErrors[name]) setFormErrors(prev => ({ ...prev, [name]: '' }));
  };

  return (
    <section id="contact" className="contact section" aria-labelledby="contact-title">
      <div className="container">
        <header className="section-header" data-eyebrow="Contact">
          <h2 id="contact-title" className="section-title">Get In Touch</h2>
          <p className="section-subtitle">Have a project in mind or just want to say hi? I'd love to hear from you</p>
        </header>

        <div className="contact__content">
          <div className="contact__info">
            <h3 className="contact__info-title">Let's build something great together</h3>
            <p className="contact__info-text">
              I'm always open to discussing new projects, collaboration opportunities, or just chatting
              about React Native and mobile development.
            </p>

            <div className="contact__methods">
              <a href={`mailto:${personalInfo.email}`} className="contact__method">
                <div className="contact__method-icon" aria-hidden="true">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                </div>
                <div className="contact__method-details">
                  <span className="contact__method-label">Email</span>
                  <span className="contact__method-value">{personalInfo.email}</span>
                </div>
              </a>

              {personalInfo.phone && (
                <a href={`tel:${personalInfo.phone.replace(/\s+/g, '')}`} className="contact__method">
                  <div className="contact__method-icon" aria-hidden="true">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                    </svg>
                  </div>
                  <div className="contact__method-details">
                    <span className="contact__method-label">Phone</span>
                    <span className="contact__method-value">{personalInfo.phone}</span>
                  </div>
                </a>
              )}

              <a href={personalInfo.links.github} className="contact__method" target="_blank" rel="noopener noreferrer">
                <div className="contact__method-icon" aria-hidden="true">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z"/>
                  </svg>
                </div>
                <div className="contact__method-details">
                  <span className="contact__method-label">GitHub</span>
                  <span className="contact__method-value">View my code</span>
                </div>
              </a>
            </div>
          </div>

          <form className="contact__form" onSubmit={handleSubmit} noValidate>
            <div className="form__group">
              <label htmlFor="name" className="form__label">Name <span className="form__required" aria-hidden="true">*</span></label>
              <input
                type="text" id="name" name="name"
                className={`form__input ${formErrors.name ? 'form__input--error' : ''}`}
                value={formData.name} onChange={handleChange} placeholder="Your name"
                aria-invalid={formErrors.name ? 'true' : 'false'}
                aria-describedby={formErrors.name ? 'name-error' : undefined}
                disabled={status === 'submitting'}
              />
              {formErrors.name && <span id="name-error" className="form__error" role="alert">{formErrors.name}</span>}
            </div>

            <div className="form__group">
              <label htmlFor="email" className="form__label">Email <span className="form__required" aria-hidden="true">*</span></label>
              <input
                type="email" id="email" name="email"
                className={`form__input ${formErrors.email ? 'form__input--error' : ''}`}
                value={formData.email} onChange={handleChange} placeholder="your@email.com"
                aria-invalid={formErrors.email ? 'true' : 'false'}
                aria-describedby={formErrors.email ? 'email-error' : undefined}
                disabled={status === 'submitting'}
              />
              {formErrors.email && <span id="email-error" className="form__error" role="alert">{formErrors.email}</span>}
            </div>

            <div className="form__group">
              <label htmlFor="subject" className="form__label">Subject <span className="form__required" aria-hidden="true">*</span></label>
              <input
                type="text" id="subject" name="subject"
                className={`form__input ${formErrors.subject ? 'form__input--error' : ''}`}
                value={formData.subject} onChange={handleChange} placeholder="Project inquiry, collaboration, etc."
                aria-invalid={formErrors.subject ? 'true' : 'false'}
                aria-describedby={formErrors.subject ? 'subject-error' : undefined}
                disabled={status === 'submitting'}
              />
              {formErrors.subject && <span id="subject-error" className="form__error" role="alert">{formErrors.subject}</span>}
            </div>

            <div className="form__group">
              <label htmlFor="message" className="form__label">Message <span className="form__required" aria-hidden="true">*</span></label>
              <textarea
                id="message" name="message"
                className={`form__textarea ${formErrors.message ? 'form__textarea--error' : ''}`}
                value={formData.message} onChange={handleChange} placeholder="Tell me about your project..." rows="5"
                aria-invalid={formErrors.message ? 'true' : 'false'}
                aria-describedby={formErrors.message ? 'message-error' : 'message-hint'}
                disabled={status === 'submitting'}
              />
              {formErrors.message ? (
                <span id="message-error" className="form__error" role="alert">{formErrors.message}</span>
              ) : (
                <span id="message-hint" className="form__hint">Minimum 20 characters</span>
              )}
            </div>

            <button type="submit" className="btn btn--primary btn--lg contact__submit" disabled={status === 'submitting'}>
              {status === 'submitting' ? (
                <>
                  <svg className="btn__spinner" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                    <circle cx="12" cy="12" r="10" strokeOpacity="0.25" />
                    <path d="M12 2a10 10 0 0 1 10 10" strokeLinecap="round" />
                  </svg>
                  Sending...
                </>
              ) : 'Send Message'}
            </button>

            {status === 'success' && (
              <div className="form__success" role="status" aria-live="polite">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
                Your email app has been opened with your message addressed to Zahir.
              </div>
            )}

            {status === 'error' && (
              <div className="form__error-msg" role="alert" aria-live="assertive">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="15" y1="9" x2="9" y2="15" />
                  <line x1="9" y1="9" x2="15" y2="15" />
                </svg>
                Something went wrong. Please try again or email me directly.
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
